module.exports = __webpack_public_path__ + "static/futur-call-3-1defe93b548fb9e121be352d36419fce.jpg";